import { Button, message, Table } from 'antd';
import { calculateColumnsWidth } from 'api/common';
import { LoadingScreen } from 'common/components';
import { createContext, useEffect, useState, useCallback } from 'react';
import FilterColumns from './FilterColumn';
import { BulkUploadFile } from './BulkUploadAndDownload';
import moment from 'moment';
import xlsx from 'json-as-xlsx';

import {
  getDashboardFilterAutpayFalseData,
  PresentmentDashboard,
  PresentmentFilterPaylaod,
  presentmentUpdateFailedToCompleteStatus,
  PresentmentPagedList,
} from 'api/nach';
import { usePresentmentFilterContext } from 'features/nach/presentment/context/PresenmentFilterProvider';
import { useAutoPayFalseTabsContext } from '..';
import { ColumnsType } from 'antd/lib/table';
import ViewAuditModal from '../../ViewAuditModal';
import DownloadAuditLogs from '../../DownloadAudit';

export const ReloadFilterListContext = createContext<any>(null);

// Initial state for the paginated list
const initialPresentmentPagedList: PresentmentPagedList = {
  currentPageIndex: 1,
  noOfRecords: 0,
  data: [],
};

function getFullDate(date: string) {
  if (date != null) {
    let dateMoment = moment(new Date(date)).format('YYYY/DD/MM HH:mm:ss');
    return dateMoment;
  }
}

function PendingFilterList() {
  const { filter, setFilter, currentActiveTabKey } = usePresentmentFilterContext();
  const { reload, autopayFalseCurrentTab } = useAutoPayFalseTabsContext();
  // const [pagedList, setPagedList] = useState<PresentmentDashboard[]>([]);
  const [pagedList, setPagedList] = useState<PresentmentPagedList>(initialPresentmentPagedList); // Use PresentmentPagedList

  const [isLoading, setIsLoading] = useState(false);
  const [isRetry, setIsRetry] = useState(false);

  // Local state for pagination parameters
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Default page size
  const [fetchedDate, setFetchedDate] = useState('');
  // filter.Username = sessionStorage.getItem('user')?.toString();
  // const isAdmin = sessionStorage.getItem('isAdmin');

  // if (isAdmin != 'true') {
  // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
  // }

  useEffect(() => {
    console.log("-auto pay false pending filters currecnt tab:", autopayFalseCurrentTab)
    if (!filter || !filter.startDate || !filter.endDate) {
      setIsLoading(true);
      setPagedList(initialPresentmentPagedList);
      // message.warn('Please select date');
      return;
    }

    // If download is requested (isExtract is true), fetch ALL data
    if (filter?.isExtract && autopayFalseCurrentTab == '1pending' && (currentActiveTabKey != 2 && currentActiveTabKey != 3 && currentActiveTabKey != 5)) {
      console.log("---DOWNLOAD TRIGGERED for auto Pay true---", filter);
      handleDownloadData();
      // setAutopayFalseCurrentTab("test")
      return
    }
    setIsLoading(true);
    // if (!filter || !filter.startDate || !filter.endDate) {
    //   //setIsLoading(true);
    //   return;
    // }
    //setIsLoading(false);
    //  setPagedList([]);
    const filterForTableFetch = { ...filter };
    delete filterForTableFetch.isExtract;
    delete filterForTableFetch.pageNo;
    delete filterForTableFetch.pageSize;
    const filterForTableFetchString = JSON.stringify(filterForTableFetch);
    if ((fetchedDate != filterForTableFetchString && !filter?.isExtract) || isRetry || reload) {
      setFetchedDate(filterForTableFetchString);
      setPagedList(initialPresentmentPagedList);


      // const newFilter: PresentmentFilterPaylaod = { ...filter, presentmentFlagId: 3 };
      const newFilter: PresentmentFilterPaylaod = {
        ...filter,
        presentmentFlagId: 3,
        pageNo: 1,
        pageSize: pageSize,
      };
      getDashboardFilterAutpayFalseData(newFilter)
        .then((res) => {
          console.log('presentment response data ', res);
          if (res.data) {
            setPagedList(res.data);
          }
        })
        .finally(() => {
          setIsLoading(true);
        });
    }
  }, [isRetry, filter, reload, currentPage, pageSize]);


  const handleDownloadData = useCallback(() => {
    const downloadPayload: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 3,
      isExtract: true, // Confirming extraction
      pageNo: 1, // Or a value your backend understands as "all pages"
      pageSize: pageSize, // Or a value your backend understands as "all items"
    };
    // const resetFilter = { isExtract: false };
    // setFilter(resetFilter);
    // console.log("resetFilter pending", filter);
    getDashboardFilterAutpayFalseData(downloadPayload)
      .then((res) => {
        console.log('Download data fetched for pending', res);
        // const resetFilter = 
        // setFilter({ prevFilter, isExtract: false });
        //setFilter({ isExtract: false });
        // console.log("resetFilter peindg set isExtract", filter)
        if (res.data && res.data.data.length > 0) { // Ensure res.data and res.data.data exist
          performExcelDownload(res.data.data); // Pass the actual data array
        } else {
          message.destroy();
          message.error('No data found for download in Auto pay False');
        }
      })
      .catch((error) => {
        console.error('Error fetching data for download:', error);
        message.error('Failed to download data.');
      })
      .finally(() => {
        // setIsLoading(true); // Hide loading after download attempt
        // const resetFilter = { ...filter, isExtract: false };
        // setFilter(resetFilter);
        //message.destroy(); // Hide loading message
        setFilter((prevFilter: PresentmentFilterPaylaod) => ({
          ...prevFilter,
          isExtract: false,
        }));
      });
  }, [filter, setFilter]); // Dependency on filter to ensure latest filter values are used


  const performExcelDownload = (dataToDownload: PresentmentDashboard[]) => {
    let settings = {
      fileName: 'presentment_Auto_Pay_false_pending',
      extraLength: 3,
      writeMode: 'writeFile',
      writeOptions: {},
      RTL: false,
    };

    const updatedData = dataToDownload.map((item: any, index) => ({
      ...item,
      NOTIFICATIONDATE: getFullDate(item.notificationDate),
      DATEOFTXN: getFullDate(item.dateOfTxn),
      CREATEDON: getFullDate(item.createdOn),
      ROWNUM: index + 1, // Add the row number (index + 1 to start from 1)
    }));

    let data = [
      {
        sheet: 'Sheet 1',
        columns: [
          { label: 'ROWNUM', value: 'ROWNUM' },
          { label: 'UMRN NO', value: 'umrnNO' },
          { label: 'Corporate Name', value: 'corporateName' },
          { label: 'Corporate User No', value: 'corporateUserNo' },
          { label: 'Amount', value: 'amount' },
          { label: 'Transaction ID REF', value: 'transactionIDREF' },
          { label: 'Unique Reference', value: 'uniqueReference' },
          { label: 'Batch No', value: 'batchNo' },
          { label: 'Created On', value: 'CREATEDON' },
          { label: 'Customer Debit AC', value: 'customerDebitAC' },
          { label: 'Customer MICR', value: 'customerMICR' },
          { label: 'Date Of Transaction', value: 'DATEOFTXN' },
          { label: 'Debitor Name', value: 'debtorName' },
          { label: 'IFSC', value: 'ifsc' },
          { label: 'Loan Type', value: 'loanType' },
          { label: 'Merchant Order Id', value: 'merchantOrderId' },
          { label: 'Merchant Subscription Id', value: 'merchantSubscriptionId' },
          { label: 'Notification Date', value: 'NOTIFICATIONDATE' },
          { label: 'Notify Response Order ID', value: 'notifyResponseOrderID' },
          { label: 'Partner Bank', value: 'partnerBank' },
          { label: 'Pre Notification Status', value: 'preNotificationStatus' },
          { label: 'Presentment Flag', value: 'presentmentFlag' },
          { label: 'Presentment Id', value: 'presentmentId' },
          { label: 'Presentment Status', value: 'presentmentStatus' },
          { label: 'Sourcing Type', value: 'sourcingType' },
          { label: 'Error Remark', value: 'reason' },
          { label: 'Error Code', value: 'errorCode' },
          { label: 'Created By', value: 'userName' },
        ],
        content: updatedData,
      },
    ];
    xlsx(data, settings);
  };


  if (!pagedList || !isLoading) {
    return <LoadingScreen />;
  }

  const handleChange = (_pagination: any, _filters: any, sorter: any) => {
    if (sorter.hasOwnProperty('column')) {
      // params.order = { field: sorter.field, dir: sorter.order };
    }
    setIsLoading(false);
    setCurrentPage(_pagination.current);
    setPageSize(_pagination.pageSize);

    // filter.Username = sessionStorage.getItem('user')?.toString();
    // if (isAdmin != 'true') {
    // filter.SourceApplicationName = sessionStorage.getItem('source')?.toString();
    // }

    // filter.PageNo = _pagination.current;
    // filter.PageSize = _pagination.pageSize;
    // const newFilter: PresentmentFilterPaylaod = { ...filter, presentmentFlagId: 3 };
    const newFilter: PresentmentFilterPaylaod = {
      ...filter,
      presentmentFlagId: 3,
      pageNo: _pagination.current,
      pageSize: _pagination.pageSize,
    };
    getDashboardFilterAutpayFalseData(newFilter)
      .then((res) => {
        if (res.data) {
          setPagedList(res.data);
        }
      })
      .finally(() => {
        setIsLoading(true);
      });
  };

  const handleRetry = (record: PresentmentDashboard) => {
    presentmentUpdateFailedToCompleteStatus({ presentmentFlagId: record.presentmentId }).then(
      (res) => {
        if (res.status == 'SUCCESS') {
          message.success('Successfully retry');
          setIsRetry((prev: boolean) => !prev);
        }
      }
    );
  };

  const RetryColumn: ColumnsType<PresentmentDashboard> = [
    {
      key: 'View',
      title: 'Action',
      dataIndex: 'View',
      ellipsis: true,
      width: 1000,
      align: 'center',
      render: (_, record) => (
        <span
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
          }}
        >
          <>
            <ViewAuditModal record={record} />
            <DownloadAuditLogs record={record} />
            {record.presentmentStatus == 'PRESENTMENT_FAILED' ||
              record.presentmentStatus === 'NOTIFY_FAILED' ||
              record.presentmentStatus === 'REDMPTION_FAILED' ? (
              <Button
                onClick={() => {
                  handleRetry(record);
                }}
                type="primary"
              >
                Retry
              </Button>
            ) : null}
          </>
        </span>
      ),
    },
  ];
  const maxWidthPerCell = 600;
  const dataTable = calculateColumnsWidth(
    [...FilterColumns, ...RetryColumn],
    pagedList.data || [],
    maxWidthPerCell
  );
  const tableHeight = 500;
  const rowKey = 'ROWNUM';

  return (
    <>
      <BulkUploadFile />
      <ReloadFilterListContext.Provider value={{ setIsRetry, isRetry }}>
        <Table
          dataSource={dataTable.source}
          columns={dataTable.columns}
          rowKey={rowKey}
          //pagination={false}
          // pagination={{
          // pageSize: 10,
          // total: pagedList.noOfRecords - 10,
          // current: pagedList.currentPageIndex == 0 ? 1 : pagedList.currentPageIndex,
          // }}
          pagination={{
            pageSize: pageSize,
            total: pagedList.noOfRecords,
            current: pagedList.currentPageIndex === 0 ? 1 : pagedList.currentPageIndex,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          }}
          scroll={{ x: dataTable.tableWidth, y: tableHeight }}
          onChange={handleChange}
        />
      </ReloadFilterListContext.Provider>
    </>
  );
}

export default PendingFilterList;
